module.exports = __webpack_public_path__ + "img/hide-tags.ef3a2eaa.svg";